import { cn } from '@fmc-digital/ui';
import { ForgotEmailContainer } from '@/components/organisms/ForgotEmailContainer';
import { forgotEmailPageStyles, forgotEmailPageMainStyles } from './forgot-email-page.styles';

/**
 * Forgot Email Page
 * Helps users recover their username/email
 */
export function ForgotEmailPage() {
  return (
    <div 
      className={cn(forgotEmailPageStyles())} 
      data-testid="forgot-email-page"
    >
      <div className={cn(forgotEmailPageMainStyles())}>
        <ForgotEmailContainer />
      </div>
    </div>
  );
}
